import { VDBText } from "@components/atoms";
import CollapsibleView from "@components/molecules/CollapsibleView";
import { useTranslation } from "react-i18next";
import styled from "styled-components/native";
import { MatchExpandDetailViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { getProductProperty } from "../ProductDetailList/utils";
import { getCommentData } from "@scenes/pdp/utils/utils";
import { useSupplierSpecificCommentInOrangeMode } from "@redux/slices/globalSlice";

const MatchExpandDetailView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  priceMode,
}: MatchExpandDetailViewProps) => {
  const { t } = useTranslation();
  const supplierSpecificCommentInOrangeMode =
    useSupplierSpecificCommentInOrangeMode();

  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.expandDetail.primary">
          <LeftLabelContainer keyMargin={20}>
            <CollapsibleView
              initExpanded={true}
              title={t("productDetailPage.comments.text")}
            >
              <Divider />
              <Container>
                <VDBText>
                  {getCommentData(
                    getProductProperty(itemDetail?.item_comment, ""),
                    itemDetail,
                    priceMode,
                    supplierSpecificCommentInOrangeMode,
                    t
                  )}
                </VDBText>
              </Container>
            </CollapsibleView>
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.expandDetail.secondary">
          <LeftLabelContainer keyMargin={20}>
            <CollapsibleView
              initExpanded={true}
              title={t("productDetailPage.comments.text")}
            >
              <Divider />
              <Container>
                <VDBText>
                  {getCommentData(
                    getProductProperty(
                      otherDetail?.[currentIndex]?.item_comment,
                      ""
                    ),
                    otherDetail?.[currentIndex],
                    priceMode,
                    supplierSpecificCommentInOrangeMode,
                    t
                  )}
                </VDBText>
              </Container>
            </CollapsibleView>
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const Container = styled.View`
  padding: 12px;
`;

const PriceDetailContainer = styled.View`
  // flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  maxwidth: 100%;
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;
export default MatchExpandDetailView;
